import { render, staticRenderFns } from "./EventBrowserStreamingComponent.vue?vue&type=template&id=8a0fd7a4&scoped=true&"
import script from "./EventBrowserStreamingComponent.vue?vue&type=script&lang=js&"
export * from "./EventBrowserStreamingComponent.vue?vue&type=script&lang=js&"
import style0 from "./EventBrowserStreamingComponent.vue?vue&type=style&index=0&id=8a0fd7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0fd7a4",
  null
  
)

export default component.exports